/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";

// Global styles — design tokens, mobile utilities, UX improvements
import "./assets/css/abitue-global.css";
// import "./assets/css/_sidebar-compact.css";
// router setup
import router from "./routes/router";
// plugin setup
Vue.use(DashboardPlugin);
import {
  Autocomplete, // 👈 adicionar
} from "element-ui";
Vue.use(Autocomplete);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
